/**
 * @function ApiClient#GetContracts
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} options = {}
 */
export async function GetContracts(cid, options = {}) {
  return await this._get(`/community/${cid}/maintenance/contracts`, options);
}
